import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getCountries } from "ticketino-api-client";

import Header from "./components/Header";

const SponsorSpeaker_Step30_TicketAddress = () => {
    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();

    const orderAddress = JSON.parse(sessionStorage.getItem("FinanzOrderAddress"));

    const [organizerId, setOrganizerId] = useState(0);

    const [addresses, setAddresses] = useState([]); // Array of address objects, one per ticket
    const [tickets, setTickets] = useState([]); // Tickets in the order

    const [countries, setCountries] = useState([]);

    const [token, setToken] = useState(sessionStorage.getItem("token"));

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);
                setToken(res.data);
                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("orderId");
        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);
                if (currentOrderId > 0) {
                    loadOrder(currentOrderId);
                    loadTickets(currentOrderId);
                } else {
                    sessionStorage.removeItem("addedPromotion");
                    navigate("/de/sponsor-speaker/home");
                }
                setOrganizerId(res.data.organizerId)
            } catch (error) {
                console.error(error);
            }
        };
        loadToken();
    }, []);

    useEffect(() => {
        if (token && language) {
            requestResources();
            loadCountries();
        }
    }, [language, token]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadCountries = async () => {
        try {
            let updatedCountries = await getCountries(language);

            const indexCh = updatedCountries.findIndex(c => c.id == 176);
            const indexDe = updatedCountries.findIndex(c => c.id == 229);
            const indexAu = updatedCountries.findIndex(c => c.id == 228);

            const ch = updatedCountries[indexCh];
            const de = updatedCountries[indexDe];
            const au = updatedCountries[indexAu];

            updatedCountries.splice(indexCh, 1);
            updatedCountries.splice(indexDe, 1);
            updatedCountries.splice(indexAu, 1);

            updatedCountries.unshift(au);
            updatedCountries.unshift(de);
            updatedCountries.unshift(ch);

            setCountries(updatedCountries);

        } catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate("/de/sponsor-speaker/home");
            }
        }
    }

    // Load tickets for the order
    const loadTickets = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}/Tickets`);
            setTickets(res.data);
            // Initialize addresses array with one address per ticket
            setAddresses(res.data.map(() => ({
                firstName: "",
                name: "",
                company: "",
                function: "",
                telephone: "",
                mobile: "",
                street: "",
                postCode: "",
                city: "",
                email: "",
                countryId: 0,
            })));
        } catch (error) {
            console.error(error);
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            if (updatedOrder === null) {
                navigate("/de/sponsor-speaker/home")
            }

            setOrder(updatedOrder);
        }
        catch (error) {
            console.error(error);
        }
    }

    const handleInputChange = (idx, e) => {
        const updated = [...addresses];
        updated[idx][e.target.name] = e.target.value;
        setAddresses(updated);
    };

    // Function to copy orderAddress to the first ticket's address fields
    const copyOrderAddressToFirstTicket = () => {
        if (!orderAddress) return;
        const updated = [...addresses];
        updated[0] = {
            firstName: orderAddress.firstName || "",
            name: orderAddress.name || "",
            company: orderAddress.company || "",
            function: orderAddress.function || "",
            telephone: orderAddress.telephone || "",
            mobile: orderAddress.mobile || "",
            street: orderAddress.street || "",
            postCode: orderAddress.postCode || "",
            city: orderAddress.city || "",
            email: orderAddress.email || "",
            countryId: orderAddress.countryId || 0,
        };
        setAddresses(updated);
    };

    // Update onSubmit to submit all addresses for all tickets
    const onSubmit = async () => {
        for (let i = 0; i < addresses.length; i++) {
            await addDataToTickets(addresses[i], i);
        }
    }

    const addDataToTickets = () => {
        // Retrieve opion1 from sessionStorage
        const option1 = localStorage.getItem("SponsorSpeakerOption1");

        if (!option1) {
            navigate("/de/sponsor-speaker/home");
            return;
        }
        if (!order?.tickets || addresses.length !== order.tickets.length) return;

        order.tickets.forEach((t, key, tickets) => {
            const address = addresses[key];
            let ticketBody = {
                firstname: address.firstName,
                name: address.name,
                company: address.company,
                function: address.function,
                email: address.email,
                mobile: address.mobile,
                street: address.street,
                postCode: address.postCode,
                city: address.city,
                option2: countries.find(c => c.id === Number(address.countryId))?.name || "",
                option3: address.telephone,
                option1: option1
            };
            axios
                .put(`${baseUrl}/Ticket/${t.id}/Address`, ticketBody)
                .then(() => {
                    if (Object.is(tickets.length - 1, key)) {
                        finishFreeOrder();
                    }
                })
                .catch((error) => console.log(error.response?.data || error));
        });
    }

    const finishFreeOrder = async () => {
        await axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(() => {
                confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            });
    };

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
        } catch (error) {
            console.error(error)
        }
    };

    // Validation for mandatory fields
    const validation = addresses.length > 0 && addresses.every(buyerInfo =>
        buyerInfo.firstName && buyerInfo.firstName.trim() !== "" &&
        buyerInfo.name && buyerInfo.name.trim() !== "" &&
        buyerInfo.company && buyerInfo.company.trim() !== "" &&
        buyerInfo.street && buyerInfo.street.trim() !== "" &&
        buyerInfo.postCode && buyerInfo.postCode.trim() !== "" &&
        buyerInfo.city && buyerInfo.city.trim() !== "" &&
        buyerInfo.email && buyerInfo.email.trim() !== "" &&
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(buyerInfo.email) &&
        buyerInfo.countryId && buyerInfo.countryId !== 0
    );

    return (
        <div className="page-container">
            <Header language={language} />
            <div className="container wrapper-small">
                <div className="row mt-2">
                    <div className="col-md-12">
                        <span className="text-title d-block">{resources?.EventName}</span>
                    </div>
                </div>
                {tickets.map((ticket, idx) => (
                    <div className="row mt-4" key={ticket.id || idx}>
                        <div className="col-md-12 mb-2">
                            <span className="text-subtitle d-block">Ticket {idx + 1}</span>
                        </div>
                        {/* Copy order address button for the first ticket */}
                        {idx === 0 && orderAddress && (
                            <div className="col-md-12 mb-3">
                                <button type="button" className="btn button-custom" onClick={copyOrderAddressToFirstTicket}>
                                    {resources?.VisitorAddressTakeOrderAddress}
                                </button>
                            </div>
                        )}
                        {/* first name */}
                        <div className="col-md-6 mb-3">
                            <label>{resources?.VisitorAddressFirstName}</label>
                            <input
                                type="text"
                                name="firstName"
                                className="form-control mt-2"
                                value={addresses[idx]?.firstName || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* last name */}
                        <div className="col-md-6 mb-3">
                            <label>{resources?.VisitorAddressLastName}</label>
                            <input
                                type="text"
                                name="name"
                                className="form-control mt-2"
                                value={addresses[idx]?.name || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* company */}
                        <div className="col-md-6 mb-3">
                            <label>{resources?.VisitorAddressCompany}</label>
                            <input
                                type="text"
                                name="company"
                                className="form-control mt-2"
                                value={addresses[idx]?.company || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* function */}
                        <div className="col-md-6 mb-3">
                            <label>{resources?.SponsorSpeakerAddressFunction}</label>
                            <input
                                type="text"
                                name="function"
                                className="form-control mt-2"
                                value={addresses[idx]?.function || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* email */}
                        <div className="col-md-12 mb-3">
                            <label>{resources?.VisitorAddressEmail}</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control mt-2"
                                value={addresses[idx]?.email || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* phone */}
                        <div className="col-md-6 mb-3">
                            <label>{resources?.VisitorAddressPhone}</label>
                            <input
                                type="text"
                                name="telephone"
                                className="form-control mt-2"
                                value={addresses[idx]?.telephone || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* mobile */}
                        <div className="col-md-6 mb-3">
                            <label>{resources?.VisitorAddressMobile}</label>
                            <input
                                type="text"
                                name="mobile"
                                className="form-control mt-2"
                                value={addresses[idx]?.mobile || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* address */}
                        <div className="col-md-12 mb-3">
                            <label>{resources?.VisitorAddressAddress}</label>
                            <input
                                type="text"
                                name="street"
                                className="form-control mt-2"
                                value={addresses[idx]?.street || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* ZIP */}
                        <div className="col-md-6 mb-3">
                            <label>{resources?.VisitorAddressZip}</label>
                            <input
                                type="text"
                                name="postCode"
                                className="form-control mt-2"
                                value={addresses[idx]?.postCode || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* City */}
                        <div className="col-md-6 mb-3">
                            <label>{resources?.VisitorAddressCity}</label>
                            <input
                                type="text"
                                name="city"
                                className="form-control mt-2"
                                value={addresses[idx]?.city || ""}
                                onChange={e => handleInputChange(idx, e)}
                            />
                        </div>
                        {/* country */}
                        <div className="col-md-12 mb-3">
                            <label>{resources?.VisitorAddressCountry}</label>
                            <select
                                className="form-select mt-2"
                                name="countryId"
                                value={addresses[idx]?.countryId || ""}
                                onChange={e => handleInputChange(idx, e)}
                            >
                                <option value=""></option>
                                {countries.map((country) => (
                                    <option key={country.id} value={country.id}>{country.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                ))}

                <div className="row mt-4">
                    <div className="col-md-6">
                        <button className="btn button-custom" onClick={() => navigate(-1)}>{resources?.Back}</button>
                    </div>
                    <div className="col-md-6 text-end">
                        <button className="btn button-custom" onClick={() => onSubmit()} disabled={!validation}>{resources?.Next}</button>
                    </div>
                </div>

                <p className="mt-4">
                    <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                </p>
            </div> 
        </div>
    )
}

export default SponsorSpeaker_Step30_TicketAddress